import { Flex, Spin } from "@ir/ui";

/**
 * Loading Spinner Component - Presentation layer
 * Single Responsibility: Displays a loading spinner
 */
const LoadingSpinner = () => {
  return (
    <Flex
      align="center"
      justifyContent="center"
      style={{
        height: "100vh",
      }}
    >
      <Spin tip="Loading..." spinning={true} />
    </Flex>
  );
};

export default LoadingSpinner;
